import useStore from '../../store/zustand/store';

const useGetUserId = () => useStore((state) => state.user?.id);

export default useGetUserId;
